module.exports = __webpack_public_path__ + "static/img/software_icon4.33d1a132.png";